import Routes from './Routes'
import { Amplify } from 'aws-amplify'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

Amplify.configure({
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID
})

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_LIVE!)

function App() {
  return (
    <Elements stripe={stripePromise}>
      <Routes />
    </Elements>
  )
}

export default App
